/**
 * <frs-header> : méga-menu « Collections » (survol + clic + clavier) et menu mobile en <dialog>.
 * Le <dialog> modal piège le focus et se ferme avec Échap nativement.
 */
class FrsHeader extends HTMLElement {
  connectedCallback() {
    this.megaButton = this.querySelector('[data-mega-button]');
    this.mega = this.querySelector('[data-mega]');
    this.menu = this.querySelector('[data-menu]');
    this.menuButton = this.querySelector('[data-menu-open]');
    this.openedAt = 0;

    if (this.megaButton && this.mega) {
      this.megaButton.addEventListener('click', () => {
        // Un survol vient d'ouvrir le menu : le clic qui suit ne doit pas le refermer.
        if (!this.mega.hidden && Date.now() - this.openedAt < 500) return;
        this.toggleMega(this.mega.hidden);
      });

      if (matchMedia('(hover: hover)').matches) {
        this.megaButton.addEventListener('mouseenter', () => this.toggleMega(true));
        this.querySelector('.frs-header').addEventListener('mouseleave', () => this.toggleMega(false));
      }

      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !this.mega.hidden) {
          this.toggleMega(false);
          this.megaButton.focus();
        }
      });

      this.addEventListener('focusout', (event) => {
        if (!this.mega.hidden && !this.querySelector('.frs-header').contains(event.relatedTarget)) {
          this.toggleMega(false);
        }
      });

      document.addEventListener('click', (event) => {
        if (!this.mega.hidden && !this.contains(event.target)) this.toggleMega(false);
      });
    }

    if (this.menu && this.menuButton) {
      this.menuButton.addEventListener('click', () => this.openMenu());
      this.menu.querySelector('[data-menu-close]').addEventListener('click', () => this.menu.close());
      // Clic sur le fond (hors du panneau) : on ferme.
      this.menu.addEventListener('click', (event) => {
        if (event.target === this.menu) this.menu.close();
      });
      this.menu.addEventListener('close', () => {
        this.menuButton.setAttribute('aria-expanded', 'false');
        document.documentElement.style.overflow = '';
      });
    }
  }

  toggleMega(open) {
    if (open && this.mega.hidden) this.openedAt = Date.now();
    this.mega.hidden = !open;
    this.megaButton.setAttribute('aria-expanded', String(open));
  }

  openMenu() {
    this.menu.showModal();
    this.menuButton.setAttribute('aria-expanded', 'true');
    document.documentElement.style.overflow = 'hidden';
  }
}

if (!customElements.get('frs-header')) customElements.define('frs-header', FrsHeader);
